import { addDays, format } from 'date-fns'
import { AgentInfo, ConsumerInfo, Payload } from '../types'
import { genModalBody } from './genModalBody'

const extensionDate = format(addDays(new Date(), 45), 'LL/dd/yyyy')

export const genRequestFormPayload = (state: any, payload: Payload): void => {
  const { body, form } = genModalBody(payload)
  state.data.relationshipType = payload.relationshipType
  state.data.accountType = payload.accountType
  state.data.requestType = payload.requestType
  state.data.onBehalf = payload.onBehalf
  state.data.onlineResponse = body
  state.data.responseForm = form
  state.data.dateExtension = form === '1627a' ? extensionDate : undefined
  if (payload.onBehalf === 'No') {
    state.data.agentFirstName = undefined
    state.data.agentMiddleName = undefined
    state.data.agentLastName = undefined
    state.data.agentSuffix = undefined
    state.data.agentEmail = undefined
    state.data.agentPhoneNumber = undefined
    state.data.agentDateOfBirth = undefined
    state.data.agentStreetAddress = undefined
    state.data.agentAddressLine2 = undefined
    state.data.agentCity = undefined
    state.data.agentState = undefined
    state.data.agentZip = undefined
    state.data.formAttachments = []
  }
}

export const genAgentFormPayload = (state: any, payload: AgentInfo): void => {
  state.data.deliveryMethod = payload.deliveryMethod
  state.data.agentFirstName = payload.firstName
  state.data.agentMiddleName = payload.middleName === '' ? undefined : payload.middleName
  state.data.agentLastName = payload.lastName
  state.data.agentSuffix = payload.suffix === '' ? undefined : payload.suffix
  state.data.agentEmail = payload.email
  state.data.agentPhoneNumber = payload.phone
  state.data.agentDateOfBirth = payload.dob
  state.data.agentStreetAddress = payload.addressLine1
  state.data.agentAddressLine2 = payload.addressLine2 === '' ? undefined : payload.addressLine2
  state.data.agentCity = payload.city
  state.data.agentState = payload.state
  state.data.agentZip = payload.zip
}

export const genConsumerFormPayload = (state: any, payload: ConsumerInfo): void => {
  state.data.deliveryMethod = payload.deliveryMethod
  state.data.consumerFirstName = payload.firstName
  state.data.consumerMiddleName = payload.middleName === '' ? undefined : payload.middleName
  state.data.consumerLastName = payload.lastName
  state.data.consumerSuffix = payload.suffix === '' ? undefined : payload.suffix
  state.data.consumerEmail = payload.email
  state.data.consumerPhoneNumber = payload.phone
  state.data.consumerAccountNumber = payload.accountNumber === '' ? undefined : payload.accountNumber
  state.data.consumerDateOfBirth = payload.dob
  state.data.consumerStreetAddress = payload.addressLine1
  state.data.consumerAddressLine2 = payload.addressLine2 === '' ? undefined : payload.addressLine2
  state.data.consumerCity = payload.city
  state.data.consumerState = payload.state
  state.data.consumerZip = payload.zip
}